import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable,  } from 'rxjs';
/* TODO.  Update this import for newer versions of Angular */
import { _throw as throwError } from 'rxjs/observable/throw';
import { retry, catchError } from 'rxjs/operators';
import {NotificationService} from "./notification-service";
import {Injector} from "@angular/core";
import notify from 'devextreme/ui/notify';

export class ErrorInterceptor implements HttpInterceptor {

  private notificationSvc: NotificationService;

  // constructor(private injector: Injector) {
  //
  // }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          }
          // if (this.notificationSvc == null) {
          //   this.notificationSvc = this.injector.get(NotificationService);
          // }
          // this.notificationSvc.notifyError(errorMessage);
          // this.notifyError(errorMessage);
          return throwError(error);
        })
      )
  }

  notifyError(message: string) {
    notify(message, 'error', 6000)
  }

}



// WEBPACK FOOTER //
// ./src/app/distributor/services/error-interceptor.ts